import { Component, Host, Prop, Watch, h } from '@stencil/core';
import type { PagesList } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-page-listing',
  styleUrl: 'cms-page-listing.scss',
  shadow: true,
})
export class CmsPageListing {
  private pageList: PagesList[];

  /**
   * set the headline
   */
  @Prop() headline: '';

  /**
   * set page list as json
   */
  @Prop() pages: PagesList[] | string;

  @Watch('pages')
  private pagesWatcher(newValue: PagesList[] | string) {
    if (newValue) {
      this.pageList =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }

  private renderListItem(pagesList: PagesList[]) {
    if (!pagesList) {
      return null;
    }
    return pagesList.map((item) => {
      const { name, pageUrl } = item;
      return (
        <li key={name} class={'page-list-item'}>
          <a class={'page-link'} href={pageUrl} title={name}>
            {name}
          </a>
        </li>
      );
    });
  }

  componentWillLoad() {
    if (!this.pages) {
      return;
    }

    this.pagesWatcher(this.pages);
  }

  render() {
    return (
      <Host>
        <div class={'page-list-container'}>
          <div class={'page-list-headline'}>
            <cms-headline
              style={{ '--cms-grid-padding': '0', '--cms-spacing-bottom': '0' }}
              headlineText={this.headline}
              headlineTag='h3'
              headlineClass='headline'
              headlinePosition='left'
              layout='full'
            />
          </div>
          <div class={'page-list-wrapper'}>
            <ul class={'page-list'}>{this.renderListItem(this.pageList)}</ul>
          </div>
        </div>
      </Host>
    );
  }
}
